import React from 'react';
import Drawer from 'react-modern-drawer';
import { FaArrowCircleRight, FaArrowCircleLeft } from 'react-icons/fa';
import * as FeatherIcon from 'react-feather';
import EventLockGrid from 'components/Drawer/EventLockGrid';

const ApplicationDrawer = () => {
    const [isOpen, setIsOpen] = React.useState(false);

    return (
        <>
            <button
                title="Widgets"
                style={{ top: 70, marginRight: '-10px' }}
                className="floating-button text-primary"
                onClick={() => setIsOpen(!isOpen)}
            >
                {isOpen ? (
                    <FeatherIcon.XCircle style={{ height: 25 }} className="enlarge" color="#4BB3BC" />
                ) : (
                    <FeatherIcon.Grid style={{ height: 25 }} className="enlarge" color="#4BB3BC" />
                )}
            </button>
            {isOpen && (
                <Drawer open={isOpen} onClose={() => setIsOpen(false)} direction="right" size="18vw" enableOverlay duration={10}>
                    <EventLockGrid />
                </Drawer>
            )}
        </>
    );
};

export default ApplicationDrawer;
